import { LESS_768_MEDIA_QUERY } from '../../../../consts/adaptive';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { cssToObject } from '../../../../../utils/cssToObject';

const {theme} = defaultTheme;

export const styles = {
  icon: {
    marginRight: 4,
    verticalAlign: 'middle',
  },

  link: {
    ...cssToObject(theme.mixin.fontTextS),
    display: 'inline-block',
    textDecoration: 'none',
    color: theme.colorVariables.textNoteDark,
  },

  [LESS_768_MEDIA_QUERY]: {
    icon: {
      display: 'none'
    },

    comma: {
      display: 'none'
    },

    link: {
      padding: [4, 12],
      marginRight: 8,
      border: '1px solid rgba(61, 149, 251, 0.25)',
      borderRadius: 2,
      backgroundColor: theme.colorVariables.bgPrimary,
      color: theme.colorVariables.link,
    }
  }
};

export type ComponentJSSClasses = typeof styles;
